import React from 'react';

const NewWindow = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 22"
            className={className}
        >
            <path d="M20.54,1.23v-.04c0-.25-.08-.49-.23-.7-.01,0-.02-.03-.04-.05l-.08-.09s-.06-.06-.09-.08c-.01,0-.03-.02-.05-.04-.2-.15-.44-.23-.7-.23h-7.06c-.65,0-1.17.52-1.2,1.17,0,.65.53,1.18,1.18,1.18h4.22l-7.73,7.72c-.22.22-.35.52-.35.83,0,.65.54,1.18,1.19,1.18.31,0,.61-.13.83-.35l7.73-7.73v4.22c0,.65.53,1.18,1.18,1.18.31,0,.61-.13.83-.35s.35-.52.35-.83V1.23s.02,0,.02,0Z" fill="#209022" strokeWidth="0" />
            <path d="M1,21.21c-.26,0-.52-.1-.71-.29-.19-.19-.29-.44-.29-.71V5.2c0-.55.45-1,1-1h8.37c.55,0,1,.45,1,1s-.45,1-1,1H2v13l12.93-.07v-7.87c0-.55.45-1,1-1s1,.45,1,1v8.86c0,.55-.44,1-1,1l-14.93.08h0Z" fill="#209022" strokeWidth="0" />
        </svg>
    );
};

export default NewWindow;
